import { DashboardLayout } from "layouts/dashboard.layout";
import { ReferredTable } from "./components/referred-table.component";

export function ReferredPage() {
  return (
    <DashboardLayout>
      <ReferredTable />
    </DashboardLayout>
  );
}
